import { render } from "./AskTheRabbi.vue?vue&type=template&id=01a87034"
import script from "./AskTheRabbi.vue?vue&type=script&lang=js"
export * from "./AskTheRabbi.vue?vue&type=script&lang=js"

import "./AskTheRabbi.vue?vue&type=style&index=0&id=01a87034&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__